import React from 'react'
import BestBuyTemplate from 'src/components/template/best-buy-loyalty'
export default (props) => <BestBuyTemplate />
